// extracted by mini-css-extract-plugin
export default {"wrapper":"keywordsHeroSection_wrapper__QxY7n","cards":"keywordsHeroSection_cards__1kRQY"};